import Intro from "../../components/intro/Intro";
import Workplace from "./Workplace";
import Clickard from "../../components/Clickard/Clickard";
import LI from "../../components/LI/LI";
import css from "./SoftwareEngineering.module.css";

const SoftwareEngineering = () => {
  return (
    <>
      <Intro
        primary="SOFTWARE ENGINEERING"
        secondary="I'm a senior full-stack software engineer. I also have deep experience with graphic design, management, and marketing. If you want to browse the projects I've worked on."
        tertiary="You're in the right place."
      />
      <div className="column p01 g1">
        <h2>RECENT PROJECTS</h2>
        <h3 className="ctext" style={{ marginTop: "3rem" }}>
          WEBSITES
        </h3>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/logo/ccc2x1.jpg",
              alt: "The Crystal Clear Consulting logo: A purple obelisk-shaked crystal (with five sides) rotated counter-clockwise 90° (so it's pointing left) against a light lavender background. The crystal uses three shades of purple.",
            }}
            isExternal
            link="https://crystal-clear-consulting.com/"
            text="Crystal Clear Consulting"
          />
          {/* <Clickard
            img={{
              src: require("./dark-matter-concepts.jpg"),
              alt: "The Crystal Clear Consulting logo: A purple obelisk-shaked crystal (with five sides) rotated counter-clockwise 90° (so it's pointing left) against a light lavender background. The crystal uses three shades of purple.",
            }}
            isExternal
            link="https://crystal-clear-consulting.com/"
            text="Dark Matter Concepts"
          /> */}

          <Clickard
            img={{
              src: require("./tj-holdman.jpg"),
              alt: "An uncut loaf of banana bread on a gray countertop, shot from directly above. It is cooked to perfection (if I may say so myself.)",
            }}
            isExternal
            link="https://tjholdman.com"
            text="TJ Holdman"
          />
          <Clickard
            img={{
              src: require("./troomi-wireless.jpg"),
              alt: "An uncut loaf of banana bread on a gray countertop, shot from directly above. It is cooked to perfection (if I may say so myself.)",
            }}
            isExternal
            link="https://shop.troomi.com/shop"
            text="Troomi Shop"
          />
        </div>
        <h3 className="ctext" style={{ marginTop: "3rem" }}>
          SOFTWARE
        </h3>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/money-bender-media/logos/600x300.jpg",
              alt: "The Bendy Budget logo: A white symbol that somewhat resembles the letter 'm' (lowercase) rotated clockwise 45 degrees against a bold orange background. (The 'm' is missing its tail in the top left, and the middle pillar is elongated.)",
            }}
            isExternal
            link="https://bendybudget.com/"
            text="Bendy Budget"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/banana_bread/loaf_2x1.jpg",
              alt: "An uncut loaf of banana bread on a gray countertop, shot from directly above. It is cooked to perfection (if I may say so myself.)",
            }}
            link="/cookbook"
            text="Interactive Cookbook"
          />
          <Clickard
            img={{
              src: require("../home/queues.png"),
              alt: "An uncut loaf of banana bread on a gray countertop, shot from directly above. It is cooked to perfection (if I may say so myself.)",
            }}
            link="/software-engineering/queues"
            text="Interactive Queue Tutorial"
          />
        </div>
      </div>

      <div className={`column g1 ${css.resume}`}>
        <h2 style={{ marginBottom: "-3rem" }}>WORK EXPERIENCE</h2>
        {/* <a
            className="button"
            href="https://storage.googleapis.com/squidslippers-media/resume-jacob-moreno.pdf"
            target="_blank"
            rel="noopener"
          >
            VIEW MY RESUME
          </a> */}

        <Workplace
          info={{
            dates: "May 2025 – Present",
            employer: "Troomi Wireless",
            location: "Orem, UT",
            role: "Senior Full-Stack Engineer",
          }}
          logo={{ src: require("./logo_troomi.jpg"), alt: "Troomi Logo" }}
        >
          <LI type="success">
            <p>Currently helping children navigate the internet safely.</p>
          </LI>
        </Workplace>

        <Workplace
          info={{
            dates: "Nov 2023 – Present",
            employer: "Mantle XM",
            location: "Herriman, UT",
            role: "Full-Stack Engineer",
          }}
          logo={{ src: require("./logo_mantle.jpg"), alt: "Mantle Logo" }}
        >
          <LI type="success">
            <p>Founded a software development and marketing consultancy.</p>
          </LI>
          <LI type="success">
            <p>
              Served 12 clients: designed and built 3 software, 4 prototypes,
              and 5 marketing websites.
            </p>
          </LI>
          <LI type="success">
            <p>
              Invented, designed, and built a budgeting software currently in
              beta with 40+ active users.
            </p>
          </LI>
          <LI type="success">
            <p>
              Interviewed, hired, mentored, and managed a full-time Junior
              Engineer.
            </p>
          </LI>
        </Workplace>

        <Workplace
          info={{
            dates: "Apr 2022 – Nov 2023",
            employer: "Strategic Education",
            location: "Remote",
            role: "Senior Software Engineer",
          }}
          logo={{
            src: require("./logo_sei.jpg"),
            alt: "Strategic Education Logo",
          }}
        >
          <LI>
            Promoted from Senior Full-Stack Engineer to AI Chatbot Team Lead;
            supervised 3 contributors.
          </LI>
          <LI>
            Created and presented reports to the CTO about the health and ROI of
            the chatbots.
          </LI>
          <LI>
            Helped to streamline operations enough to reduce team size from 13
            to 9 while maintaining output.
          </LI>
          <LI>
            Developed AI chatbots that resolved 93% of 3M+ support requests
            (20,000+/day) with 91% satisfaction from surveyed students.
          </LI>
          <LI>
            Led the development of and served as Project Manager for Enterprise
            AI, a ChatGPT wrapper that analyzed and filtered inputs before
            submission.
          </LI>
          <LI>
            Led the development of Odyssey, a project that saves $5 million
            annually by replacing Soomo.
          </LI>
        </Workplace>

        <Workplace
          info={{
            dates: "Sep 2021 – Apr 2022",
            employer: "Customer Dynamics",
            location: "Remote",
            role: "Lead React + QA Engineer",
          }}
          logo={{
            src: require("./logo_customer_dynamics.jpg"),
            alt: "Customer Dynamics Logo",
          }}
        >
          <LI>
            Appointed as the lead developer, subject matter expert, and final
            approver for all React-related work.
          </LI>
          <LI>
            Led frontend development for a B2B software suite used by 500+
            clients (30,000+ daily users).
          </LI>
          <LI>
            Iteratively re-architected a monolithic React app, reducing bundle
            size by 80% and load time by 3 seconds.
          </LI>
          <LI>
            Led the QA team with 0 incidents in an industry where past errors
            have cost $2M+ per infraction.
          </LI>
          <LI>
            Wrote and recorded a branded video series on automated testing and
            QA best practices.
          </LI>
        </Workplace>
      </div>
      <div className="column p01 g1">
        <h2 className="ctext">WORK WITH ME</h2>
        <div className="columns_3">
          <a
            className="link"
            href="mailto:jacob.w.moreno@gmail.com?subject=Let's work together."
          >
            jacob.w.moreno@gmail.com
          </a>
          <a className="button" href="sms:+18018678774">
            801-867-8774
          </a>
          <a
            className="link"
            rel="noopener"
            target="_blank"
            href="https://www.linkedin.com/in/jacob-moreno/"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </>
  );
};

export default SoftwareEngineering;
